var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"elevation":"2","fab":"","raised":"","rounded":"","color":"red accent-4","small":"","dark":""},on:{"click":_vm.simulateError}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-alert-decagram")])],1)]}}])},[_c('span',[_vm._v("Simulate an error call here 🤬 😱")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }